module.exports = __webpack_public_path__ + "static/media/WhiteCloseBlueBackground.b39909aa.svg";